import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Typography,
  Divider,
  DatePicker,
  theme,
} from "antd";
import { Content } from "antd/es/layout/layout";
import Heading from "../../../../../components/common/heading";
import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useContext,
} from "react";
import { routes } from "../../../../../routes";
const { useToken } = theme;

const { Title } = Typography;
const dateFormat = "DD/MM/YYYY";
const { RangePicker } = DatePicker;
const { Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;

export const convertVOC = (keytext, data, type) => {
  let text = "";

  data.map((x) => {
    if (x.vocUniqueId === keytext) {
      text = x.vocDetailTh;
    }
  });

  return text;
};

const VoiceOfCustomerView = (props) => {
  const { token } = useToken();
  const [form] = Form.useForm();
  const {
    dataDetail,
    dropDownproductRequirement,
    dropDowncustomerSupport,
    dropDowncustomerExpact,
    dropDownbusinessRequire,
    dropDownotherProductExpect,
    dropDownotherSupportExpect,
    dropDownotherBusinessExpect,
    productRequirement,
    customerSupport,
    customerExpact,
    businessRequire,
    otherProductExpect,
    otherSupportExpect,
    otherBusinessExpect,
    otherExpect,

    dropDownproductRequirement_v2,
    dropDowncustomerSupport_v2,
    dropDowncustomerExpact_v2,
    dropDownbusinessRequire_v2,
    dropDownotherProductExpect_v2,
    dropDownotherSupportExpect_v2,
    dropDownotherBusinessExpect_v2,
    productRequirement_v2,
    customerSupport_v2,
    customerExpact_v2,
    businessRequire_v2,
    otherProductExpect_v2,
    otherSupportExpect_v2,
    otherBusinessExpect_v2,
    otherExpect_v2,
  } = props;

  return (
    <Content style={{ paddingTop: 15 }}>
      <Row gutter={[8, 16]} className="card">
        <Col span={24}>
          <Heading
            text={"Voice of Customer เสียงของลูกค้า (VOC)"}
            size={4}
            style={{ margin: 0, color: token.thPrimary }}
          />
          <Divider />
        </Col>
        <Col span={24}>
          <Text strong>(VOC) ความต้องการต่อผลิตภัณฑ์/การบริการ ของ กนอ.</Text>
        </Col>

        <Col span={16}>
          <Form.Item
            label="1. ลูกค้ามีความต้องการ ด้านผลิตภัณฑ์และบริการ ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
            name={"vcq1"}
            style={{ paddingBottom: 24 }}
          >
            {/* {convertVOC(item, dropDownproductRequirement)} */}
            {/* {productRequirement && productRequirement.length > 0 ? (
              <>
                {productRequirement.map((item) => {
                  return (
                    <>
                      <Text>
                        
                        {item
                          ? convertVOC(
                              item,
                              dropDownproductRequirement == "" ? dropDownproductRequirement
                              : dropDownproductRequirement_v2
                            )
                          : "-"}
                      </Text>
                      <br />
                    </>
                  );
                })}
              </>
            ) : (
              <>
                <Text>-</Text>
              </>
            )} */}
            {productRequirement && productRequirement.length > 0 ? (
              
              <>
            {productRequirement?.map((item) => {
                  console.log(item)
                  const v2 = item ? convertVOC(item, dropDownproductRequirement_v2) : "";
                  const old = item ? convertVOC(item, dropDownproductRequirement) : "";
                  console.log("v2 : ",v2);
                  console.log("old : ",old);
                  console.log("item : ",item);

                  return (
                    <React.Fragment key={`${item}`}>
                      <Text>
                        {!item
                          ? "-"
                          : (v2 && v2 !== item && v2 !== "-" ? v2
                            : (old && old !== item && old !== "-" ? old : "-"))}
                      </Text>
                      <br />
                    </React.Fragment>
                  );
                })}
                </>
                ) : (
                  <>
                    <Text>-</Text>
                  </>
                )}
          </Form.Item>
          <Form.Item
            label="2. ลูกค้ามีความคาดหวังที่นอกเหนือจากความต้องการ ด้านผลิตภัณฑ์และบริการ ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
            name={"vcq2"}
            style={{ paddingBottom: 24 }}
          >
                        {/* {convertVOC(item, dropDowncustomerSupport)} */}
           
            {/* {customerSupport && customerSupport.length > 0 ? (
              <>
                {customerSupport.map((item) => {
                  return (
                    <>
                      <Text>

                        {item
                          ? convertVOC(
                              item,
                              dropDowncustomerSupport == "" ? dropDowncustomerSupport
                              : dropDowncustomerSupport_v2
                            )
                          : "-"}
                      </Text>
                      <br />
                    </>
                  );
                })}
              </>
            ) : (
              <>
                <Text>-</Text>
              </>
            )} */}
            {customerSupport && customerSupport.length > 0 ? (
              
              <>
            {customerSupport?.map((item) => {
                  console.log(item)
                  const v2 = item ? convertVOC(item, dropDowncustomerSupport_v2) : "";
                  const old = item ? convertVOC(item, dropDowncustomerSupport) : "";
                  console.log("v2 : ",v2);
                  console.log("old : ",old);
                  console.log("item : ",item);

                  return (
                    <React.Fragment key={`${item}`}>
                      <Text>
                        {!item
                          ? "-"
                          : (v2 && v2 !== item && v2 !== "-" ? v2
                            : (old && old !== item && old !== "-" ? old : "-"))}
                      </Text>
                      <br />
                    </React.Fragment>
                  );
                })}
                </>
                ) : (
                  <>
                    <Text>-</Text>
                  </>
                )}
          </Form.Item>

          <Form.Item
            label="3. ลูกค้ามีความต้องการ ด้านการทำธุรกรรม (อนุมัติอนุญาตสิทธิประโยชน์) ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
            name={"vcq3"}
            style={{ paddingBottom: 24 }}
          >
                        {/* {convertVOC(item, dropDownbusinessRequire)} */}

            {/* {businessRequire && businessRequire.length > 0 ? (
              <>
                {businessRequire.map((item) => {
                  return (
                    <>
                      <Text>
                        {item
                          ? convertVOC(
                              item,
                              dropDownbusinessRequire == "" ? dropDownbusinessRequire
                              : dropDownbusinessRequire_v2
                            )
                          : "-"}
                        </Text>
                      <br />
                    </>
                  );
                })}
              </>
            ) : (
              <>
                <Text>-</Text>
              </>
            )} */}
            {businessRequire && businessRequire.length > 0 ? (
              
              <>
            {businessRequire?.map((item) => {
                  console.log(item)
                  const v2 = item ? convertVOC(item, dropDownbusinessRequire_v2) : "";
                  const old = item ? convertVOC(item, dropDownbusinessRequire) : "";
                  console.log("v2 : ",v2);
                  console.log("old : ",old);
                  console.log("item : ",item);

                  return (
                    <React.Fragment key={`${item}`}>
                      <Text>
                        {!item
                          ? "-"
                          : (v2 && v2 !== item && v2 !== "-" ? v2
                            : (old && old !== item && old !== "-" ? old : "-"))}
                      </Text>
                      <br />
                    </React.Fragment>
                  );
                })}
                </>
                ) : (
                  <>
                    <Text>-</Text>
                  </>
                )}
          </Form.Item>
          <Form.Item
            label="4. ลูกค้ามีความต้องการ/คาดหวัง ด้านการจัดการความสัมพันธ์(CRM) ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
            name={"vcq4"}
          >
                        {/* {convertVOC(item, dropDowncustomerExpact)} */}

            {/* {customerExpact && customerExpact.length > 0 ? (
              <>
                {customerExpact.map((item) => {
                  return (
                    <>
                      <Text>
                        {item
                          ? convertVOC(
                              item,
                              dropDowncustomerExpact == "" ? dropDowncustomerExpact
                              : dropDowncustomerExpact_v2
                            )
                          : "-"}
                      </Text>
                      <br />
                    </>
                  );
                })}
              </>
            ) : (
              <>
                <Text>-</Text>
              </>
            )} */}
            {customerExpact && customerExpact.length > 0 ? (
              
              <>
            {customerExpact?.map((item) => {
                  console.log(item)
                  const v2 = item ? convertVOC(item, dropDowncustomerExpact_v2) : "";
                  const old = item ? convertVOC(item, dropDowncustomerExpact) : "";
                  console.log("v2 : ",v2);
                  console.log("old : ",old);
                  console.log("item : ",item);

                  return (
                    <React.Fragment key={`${item}`}>
                      <Text>
                        {!item
                          ? "-"
                          : (v2 && v2 !== item && v2 !== "-" ? v2
                            : (old && old !== item && old !== "-" ? old : "-"))}
                      </Text>
                      <br />
                    </React.Fragment>
                  );
                })}
                </>
                ) : (
                  <>
                    <Text>-</Text>
                  </>
                )}
          </Form.Item>
        </Col>
        <Divider strong dashed />
        <Col span={16}>
          <Col span={24}>
            <Text strong>
              (VOC) ความคาดหวัง นอกเหนือจากผลิตภัณฑ์/บริการของ กนอ.
            </Text>
          </Col>
          <Form.Item
            label="1. ลูกค้ามีความคาดหวังที่นอกเหนือจากความต้องการ ด้านผลิตภัณฑ์และบริการ ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
            name={"voq1"}
            style={{ paddingBottom: 24, paddingTop: 24 }}
          >
                        {/* {convertVOC(item, dropDownotherProductExpect)} */}

            {/* {otherProductExpect && otherProductExpect.length > 0 ? (
              <>
                {otherProductExpect.map((item) => {
                  return (
                    <>
                      <Text>

                        {item
                          ? convertVOC(
                              item,
                              dropDownotherProductExpect == "" ? dropDownotherProductExpect
                              : dropDownotherProductExpect_v2
                            )
                          : "-"}
                      </Text>
                      <br />
                    </>
                  );
                })}
              </>
            ) : (
              <>
                <Text>-</Text>
              </>
            )} */}
            {otherProductExpect && otherProductExpect.length > 0 ? (
              
              <>
            {otherProductExpect?.map((item) => {
                  console.log(item)
                  const v2 = item ? convertVOC(item, dropDownotherProductExpect_v2) : "";
                  const old = item ? convertVOC(item, dropDownotherProductExpect) : "";
                  console.log("v2 : ",v2);
                  console.log("old : ",old);
                  console.log("item : ",item);

                  return (
                    <React.Fragment key={`${item}`}>
                      <Text>
                        {!item
                          ? "-"
                          : (v2 && v2 !== item && v2 !== "-" ? v2
                            : (old && old !== item && old !== "-" ? old : "-"))}
                      </Text>
                      <br />
                    </React.Fragment>
                  );
                })}
                </>
                ) : (
                  <>
                    <Text>-</Text>
                  </>
                )}
          </Form.Item>
          <Form.Item
            label="2. ลูกค้ามีความคาดหวังที่นอกเหนือจากความต้องการ ด้านผลิตภัณฑ์และบริการ ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
            name={"voq2"}
            style={{ paddingBottom: 24 }}
          >
                        {/* {convertVOC(item, dropDownotherSupportExpect)} */}
            {/* {otherSupportExpect && otherSupportExpect.length > 0 ? (
              <>
                {otherSupportExpect.map((item) => {
                  return (
                    <>
                      <Text>
                        {item
                          ? convertVOC(
                              item,
                              dropDownotherSupportExpect == "" ? dropDownotherSupportExpect
                              : dropDownotherSupportExpect_v2
                            )
                          : "-"}
                      </Text>
                      <br />
                    </>
                  );
                })}
              </>
            ) : (
              <>
                <Text>-</Text>
              </>
            )} */}
            {otherSupportExpect && otherSupportExpect.length > 0 ? (
              <>
            {otherSupportExpect?.map((item) => {
                  console.log(item)
                  const v2 = item ? convertVOC(item, dropDownotherSupportExpect_v2) : "";
                  const old = item ? convertVOC(item, dropDownotherSupportExpect) : "";
                  console.log("v2 : ",v2);
                  console.log("old : ",old);
                  console.log("item : ",item);

                  return (
                    <React.Fragment key={`${item}`}>
                      <Text>
                        {!item
                          ? "-"
                          : (v2 && v2 !== item && v2 !== "-" ? v2
                            : (old && old !== item && old !== "-" ? old : "-"))}
                      </Text>
                      <br />
                    </React.Fragment>
                  );
                })}
                </>
                ) : (
                  <>
                    <Text>-</Text>
                  </>
                )}
          </Form.Item>

          <Form.Item
            label="3.ลูกค้ามีความ คาดหวังที่นอกเหนือจากความต้องการ ด้านสนับสนุนลูกค้า ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
            name={"voq3"}
            style={{ paddingBottom: 24 }}
          >
                        {/* {convertVOC(item, dropDownotherBusinessExpect)} */}

            {/* {otherBusinessExpect && otherBusinessExpect.length > 0 ? (
              <>
                {otherBusinessExpect.map((item) => {
                  return (
                    <>
                      <Text>
                        {item
                          ? convertVOC(
                              item,
                              dropDownotherBusinessExpect == "" ? dropDownotherBusinessExpect
                              : dropDownotherBusinessExpect_v2
                            )
                          : "-"}
                      </Text>
                      <br />
                    </>
                  );
                })}
              </>
            ) : (
              <>
                <Text>-</Text>
              </>
            )} */}
            {otherBusinessExpect && otherBusinessExpect.length > 0 ? (
              
              <>
            {otherBusinessExpect?.map((item) => {
                  console.log(item)
                  const v2 = item ? convertVOC(item, dropDownotherBusinessExpect_v2) : "";
                  const old = item ? convertVOC(item, dropDownotherBusinessExpect) : "";
                  console.log("v2 : ",v2);
                  console.log("old : ",old);
                  console.log("item : ",item);

                  return (
                    <React.Fragment key={`${item}`}>
                      <Text>
                        {!item
                          ? "-"
                          : (v2 && v2 !== item && v2 !== "-" ? v2
                            : (old && old !== item && old !== "-" ? old : "-"))}
                      </Text>
                      <br />
                    </React.Fragment>
                  );
                })}
                </>
                ) : (
                  <>
                    <Text>-</Text>
                  </>
                )}
          </Form.Item>

          <Form.Item
            label="4. Other VOC"
            name={""}
            style={{ paddingBottom: 24 }}
          >
            {otherExpect && otherExpect.length > 0 ? (
              <>
                <Text>
                  {otherExpect}
                </Text>
              </>
            ) : (
              <>
              </>
            )}
            {!otherExpect && otherExpect_v2 && otherExpect.length > 0 ? (
              <>
                <Text>
                  {otherExpect_v2}
                </Text>
              </>
            ) : (
              <>
              </>
            )}
          </Form.Item>
        </Col>
      </Row>
    </Content>
  );
};

export default VoiceOfCustomerView;
